<template>
  <div
    class="ai-disclosure mt-auto"
    v-html="disclaimerHtml"
  />
</template>

<script setup>
import { l, lreplace } from '@utils/toolbox';

const disclaimerHtml = lreplace('chat.disclaimer', {
	generalPolicyLink: `<a href="${l('global.navigation.informationLink')}?view=privacyPolicy">${l('infopage.privacy_policy.title').toLowerCase()}</a>`,
	privacyPolicyLink: `<a href="${l('global.navigation.informationLink')}?view=generalPolicy">${l('infopage.policy.h3').toLowerCase()}</a>`
});
</script>

<style scoped lang="scss">
.ai-disclosure {
  padding: 1rem 1.5rem;
  background: $color-grey-100;
  border-radius: $borderRadius-md;
  color: $color-grey-600;
  text-align: center;
  font-size: 1.4rem;


  @include breakpoint_up(md) {
    max-width: 70%;
  }
}
</style>
